import { ParamType, VectorTypeEnum } from "../../enums";
import { CalcNodeInterface } from "../../schemas";
import { GraphAll } from "../../utils";


export const getSIZE_RANGE = (row: CalcNodeInterface | undefined) => {
    return Math.ceil(Math.max(
        6,
        row?.V0 || 0,
        row?.V1 || 0,
        row?.V2 || 0,
        row?.Va || 0,
        row?.Vb || 0,
        row?.Vc || 0,
    ));
}

export const getVectors = (row: CalcNodeInterface | undefined, showV0: boolean): (GraphAll | null) => {
    if (!row) return null;
    let a1 = [row?.V1,row?.phi_1,0.0,0.0];
    let a2 = [row?.V2,row?.phi_2,0.0,0.0];
    let a0 = [row?.V0,row?.phi_0,0.0,0.0];
    let graphs = new GraphAll(ParamType.Voltage, showV0, a1, a2, a0);
    return graphs;
};

export const getNodeChartLayout = (
    plotWidth: number,
    plotHeight: number,
    showLegend: boolean,
    SIZE_RANGE: number = 0,

) => {
    let gridStep = 5;
    if (SIZE_RANGE <= 200) gridStep = 50;
    if (SIZE_RANGE <= 100) gridStep = 25;
    else if (SIZE_RANGE <= 50) gridStep = 10;
    else if (SIZE_RANGE <= 25) gridStep = 5;
    else if (SIZE_RANGE <= 10) gridStep = 2;
    else if (SIZE_RANGE <= 1) gridStep = 0.25;

    // Generate annotations for row and column labels
    const generateAnnotations = () => {
        const annotations = [];
        annotations.push({
            x: 0,
            y: 0, // Position above the top row
            text: `0`,
            showarrow: false,
            font: { size: 8, color: 'gray' },
            xanchor: 'left',
            yanchor: 'bottom'
        });
        // Column labels (top of grid)
        for (let j = gridStep; j < SIZE_RANGE; j += gridStep) {
            annotations.push({
                x: j,
                y: 0, // Position above the top row
                text: `${j}`,
                showarrow: false,
                font: { size: 8, color: 'gray' },
                xanchor: 'center',
                yanchor: 'top'
            });
            annotations.push({
                x: -j,
                y: 0, // Position above the top row
                text: `-${j}`,
                showarrow: false,
                font: { size: 8, color: 'gray' },
                xanchor: 'center',
                yanchor: 'top'
            });
        }

        // Row labels (left of grid)
        for (let i = gridStep; i < SIZE_RANGE; i += gridStep) {
            annotations.push({
                x: -0.5, // Position left of the first column
                y: i,
                text: `${i}`,
                showarrow: false,
                font: { size: 8, color: 'gray' },
                xanchor: 'right',
                yanchor: 'middle'
            });
            annotations.push({
                x: -0.5, // Position left of the first column
                y: -i,
                text: `-${i}`,
                showarrow: false,
                font: { size: 8, color: 'gray' },
                xanchor: 'right',
                yanchor: 'middle'
            });
        }

        return annotations;
    };
    return {
        barmode: 'group',
        legend: {
            groupclick: "toggleitem",
        },
        title: 'Quiver Plot with Plotly.js',
        width: plotWidth,
        height: plotHeight,
        margin: {
            l: 0,
            r: 0,
            b: 0,
            t: 20,
            pad: 1,
        },
        xaxis: {
            range: [-SIZE_RANGE, SIZE_RANGE],
            showticklabels: true,
            tick0: 0,
            dtick: gridStep,
            showgrid: true,
            zeroline: true,
            title: 'X'
        },
        yaxis: {
            range: [-SIZE_RANGE, SIZE_RANGE],
            showticklabels: true,
            tick0: 0,
            dtick: gridStep,
            showgrid: true,
            zeroline: true,
            title: 'Y'
        },
        annotations: generateAnnotations(),
        showlegend: showLegend,
        // plot_bgcolor: '#a8a8a8', // Background color of the plotting area
        // paper_bgcolor: '#949494' // Background color of the entire chart area

    };
};

export const getNodeChartData = (vectors: (GraphAll|null), translations: any): object[] => {
    // Create the quiver plot
    if (vectors==null) {return [];}
    const chartVectors = [];
    let vecs =  vectors.vectors;
    for (let i = 0; i < vecs.length; i++) {
        if(!vecs[i]) continue;
        if(vecs[i].exist==false) continue;
        
        let legendGroupName: string = "";
        if (vecs[i].type_vec.legendgroup == VectorTypeEnum.Phase) {
            legendGroupName = translations.vectorTypeEnum.phase;
        } else if (vecs[i].type_vec.legendgroup == VectorTypeEnum.Sequence) {
            legendGroupName = translations.vectorTypeEnum.sequence;
        } else if (vecs[i].type_vec.legendgroup == VectorTypeEnum.Linear) {
            legendGroupName = translations.vectorTypeEnum.linear;
        }

        chartVectors.push({
            type: "scatter",
            x: [vecs[i]?.x0, vecs[i]?.x1],
            y: [vecs[i]?.y0, vecs[i]?.y1],
            mode: 'lines+markers',
            marker: { symbol: 'arrow', size: 10, angleref: 'previous' },
            legendgroup: legendGroupName,
            legendgrouptitle: {'text': legendGroupName},
            line: { color: vecs[i].type_vec.color, width: vecs[i].type_vec.line_widths },
            name: vecs[i].name,
        });
        chartVectors.push({
            type: 'scatter',
            x: [ vecs[i]?.XCoordPointName],
            y: [ vecs[i]?.YCoordPointName],
            mode: 'text',
            legendgroup: legendGroupName,
            text: [vecs[i].name],
            textposition: vecs[i].TextPosition, // Position the text
            textfont: { size: 12, color: vecs[i].type_vec.color },
            name: vecs[i].name,
            showlegend: false
        });
    }
    return chartVectors;
}
  

